import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3088">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3089">
        <div data-id="element-3090">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3091">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3092">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3093">
          <Card className="p-6" data-id="element-3094">
            <div className="flex items-center gap-4" data-id="element-3095">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3096">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3097" />
              </div>
              <div data-id="element-3098">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3099">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3100">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3101">
            <div className="flex items-center gap-4" data-id="element-3102">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3103">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3104" />
              </div>
              <div data-id="element-3105">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3106">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3107">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3108">
            <div className="flex items-center gap-4" data-id="element-3109">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3110">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3111" />
              </div>
              <div data-id="element-3112">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3113">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3114">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3115">
            <div className="flex items-center gap-4" data-id="element-3116">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3117">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3118" />
              </div>
              <div data-id="element-3119">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3120">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3121">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3122">
          <div className="p-6 border-b border-gray-200" data-id="element-3123">
            <h2 className="font-bold text-gray-900" data-id="element-3124">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3125">
            <table className="w-full text-left text-sm" data-id="element-3126">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3127">
                <tr data-id="element-3128">
                  <th className="px-6 py-4 font-medium" data-id="element-3129">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3130">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3131">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3132">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3133">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3134">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3135">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3136">
                {loading ? <tr data-id="element-3137">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3138">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3139">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3140">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3141">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3142">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3143">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3144">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3145">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3146">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3147">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3148">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3149">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}